<template>
  <div class="home">
    <transition name="fade">
      <div v-show="loaderVisible">
        <loader />
		  </div>
    </transition>
    <div v-if="this.$store.state.projects" class="prj-list-wrapper">
      <div v-if="this.type === 'list'">
        <div class='r relative section-page-title'>
          <div class='c-12'>
            <h1 class='txt-page-title'>{{this.$store.state.sortPrj}} Projects</h1>
          </div>
        </div>
        <project v-for="project in filteredProjects"
        :key="project.slug" 
        :slug="project.slug" 
        :title="project.title.rendered" 
        :excerpt="project.excerpt.rendered"
        :isFeatured="project.acf.featured"
        :isCompany="project.acf.company"
        :isFreelance="project.acf.freelance"
        :isPersonal="project.acf.personal" 
        :tags="getTagName(project.tags)" 
        :client="project.acf.client"  
        :previewImage ="project.better_featured_image.source_url"  
        :problem="project.acf.problem" 
        :objective="project.acf.objective"
        :date="project.project_date">
        </project>
      </div>
      <div v-if="this.type === 'single'">
        <project v-if="singleProject" 
        :slug="singleProject.slug" 
        :title="singleProject.title.rendered" 
        :excerpt="singleProject.excerpt.rendered"
        :tags="getTagName(singleProject.tags)" 
        :client="singleProject.acf.client" 
        :fullImage ="singleProject.better_featured_image.source_url" 
        :content="singleProject.content.rendered" :problem="singleProject.acf.problem" 
        :objective="singleProject.acf.objective"
        :credits="singleProject.acf.credits"
        :metaTitle="singleProject.yoast_meta[3].content"
        :metaDesc="singleProject.yoast_meta[4].content"
        :metaType="singleProject.yoast_meta[2].content"
        :metaUrl="singleProject.yoast_meta[5].content"
        :metaImage="singleProject.yoast_meta[8].content"
        :metaTwitter="singleProject.yoast_meta[11].content"
        >
        </project>
        <div v-if="nextProject" class='nextprev-project-wrapper'>
          <div class='r next-project-inner'>
            <p class='c-12'>Next {{ this.$store.state.sortPrj.toLowerCase() }} project</p>
            <div class='c-10'>
              <p class='txt-page-title text-next-project-title'>{{ nextProject.title.rendered }}</p>
            </div>
            <div class='c-2 prj-thumb-wrapper'>
              <div :style="{backgroundImage:`url(${nextProject.better_featured_image.source_url})`}" class="prj-thumb"></div>
            </div>
            <div class='c-12'>
              <router-link :to="'/project/' + nextProject.slug" class='textlink'><span v-on:click="scrollToTop">View this project</span></router-link>
            </div>
          </div>
        </div>
        <div v-if="!nextProject" class='nextprev-project-wrapper'>
          <!-- There is no more {{ this.$store.state.sortPrj.toLowerCase() }} project. <br /> -->
          <router-link to="/" class='textlink'><span v-on:click="scrollToTop">Back to {{ this.$store.state.sortPrj.toLowerCase() }} project list</span></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import componetnts
import loader from '/views/loader'
import project from '/views/project'

export default {
  name: 'projects',
  props: {
		type: {
			type: String,
			required: true
    }
	},
  components: {
    loader,
    project
  },
  data () {
    return {
      singleProject: null,
      currentOrder: 'date',
      projTypes: null,
      loaderVisible: true,
      nextProject: null
    }
  },
  created () {
    if(this.type === 'single') {
      // If we're viewing component in single post mode, grab the post and if not found send to 404 page
			this.getSingleProject().then(null, () => {
				this.$router.push({name: 'pageNotFound'})
      });
      // RUN getNextProject()
      setInterval(() => {
        if(this.singleProject) {
          this.getNextProject()
        }
      }, 2000)
    }
    
    setInterval(() => {
      if(this.$store.state.projects) {
        // HIDE LOADER AFTER 3 SEC
        this.loaderVisible = false
      }
    }, 2000)
  },
  methods: {
    getSingleProject: function() {
			return new Promise((resolve, reject) => {	
				this.$store.dispatch('getProjects').then(() => {
					var foundProject = false;
					this.$store.state.projects.filter((project) => {
						if(project.slug === this.$route.params.slug) {
							this.singleProject = project;
							foundProject = true;
						}
					});
					foundProject ? resolve() : reject();
				})
			})
    },
    getNextProject: function() {
      this.filteredProjects.filter((project) => {
        if(project.slug === this.$route.params.slug) {
          // FIND WHERE THE CURRENT PROJECT EXSISTS
          var loc = this.filteredProjects.indexOf(project)
          // STORE NEXT PROJECT OBJECT IF THERE IS
          if(loc < this.filteredProjects.length) {
            this.nextProject = this.filteredProjects[loc+1]
          } else {
            this.nextProject = null
          }
        }
      });
    },
    // Returns tag name when passed ID
    getTagName: function(tagIds) {
      var tagNames = []
      tagIds.forEach((tagId) => {
        var tagname = 'unknown'
        this.$store.state.tags.filter(function(tag) {
          if(tag.id === tagId) {
            tagname = tag.name
            tagNames.push(tagname)
          }
        })
      })
      tagIds = tagNames
      return tagNames
    },
    // SCROLL TO TOP
    scrollToTop: function() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  },
  computed: {
    filteredProjects: function () {
      var category = this.selectedCategory;
      // Sort projects by project date
      var sortedProjects = this.$store.state.projects.slice().sort((a,b) => b.acf.project_date - a.acf.project_date)
			
			if(this.$store.state.sortPrj === "Featured") {
        return sortedProjects.filter(project => {
          return project.acf.featured
				})
			} else if(this.$store.state.sortPrj === "Company") {
        return sortedProjects.filter(project => {
          return (project.acf.project_type || '').includes("Company")
				})
			} else if(this.$store.state.sortPrj === "Freelance") {
        return sortedProjects.filter(project => {
          return (project.acf.project_type || '').includes("Freelance")
				})
      } else if(this.$store.state.sortPrj === "Personal") {
        return sortedProjects.filter(project => {
          return (project.acf.project_type || '').includes("Personal")
				})
      } 
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.filter-wrapper {
  clear: both;
  display: inline-block;
  position: absolute;
  width: 300%;
  padding-top: 0 !important;
  left: 0;
}

input.prj-tab {
  position: absolute;
  left: -99999em;
  top: -99999em;

	& + label {
		cursor: pointer;
		float: left;
    position: relative;
    color: $disable;
    // margin-right: 1rem;
        
     &:hover {
       color: $accent;
     }
	}

	&:checked + label {
    color: $primary;
		z-index: 1;
	}
}

#filter-wrapper {
  transition: all .3s ease-in-out;
}

.prj-list-wrapper {
  overflow-x: hidden;
  padding: 0 24px;
  @include media("<=tablet") {
    padding: 24px 24px 40px;
  }
}

.nextprev-project-wrapper {
  width: 100%;
  height: 100vh;
  background-color: $primary;
  color: $wallpaper;
  margin-top: 20vh;
  margin-left: -24px;
  padding: 24px;
  @include flex(left, center);
}

.next-project-inner {
  width: 100%;
}

.text-next-project-title {
  margin-bottom: var(--space-xxxs)
}

.textlink {
  color: $wallpaper;
  background-image: linear-gradient($wallpaper, $wallpaper);
}

</style>